<template>
  <div style="padding-bottom: 50px">
    <van-sticky>
      <navbar :title="title" />
    </van-sticky>

    <van-form>
      <h2 class="van-form-title">审核信息</h2>
      <van-field
        v-model="purchase_status[product.purchase_status]"
        label="审核情况"
        readonly
      />
      <div v-if="auditShow">
        <van-field v-model="product.auditor_name" label="审核人" readonly />
        <van-field v-model="product.check_date" label="审核日期" readonly />
        <van-field
          v-model="product.settle_remark"
          rows="3"
          autosize
          label="办结备注"
          type="textarea"
        />
      </div>
      <h2 class="van-form-title">商品信息</h2>
      <van-field v-model="product.user_name" label="申请人" readonly />
      <van-field v-model="product.product_name" label="采购商品" readonly />
      <van-field v-model="product.supplier" label="供应商" readonly />
      <van-field v-model="product.order_name" label="项目名称" readonly />
      <van-field v-model="product.order_code" label="订单编号" readonly />
      <van-field v-model="product.quantity" label="采购数量" readonly />
      <van-field v-model="product.unit_name" label="商品单位" readonly />
      <van-field v-model="product.create_date" label="申请日期" readonly />
      <van-field
        v-model="product.purchase_remark"
        rows="3"
        autosize
        label="备注"
        type="textarea"
      />

      <div
        v-show="
          this.product.purchase_status == 1 || this.product.purchase_status == 5
        "
      >
        <h2 class="van-form-title">付款信息</h2>
        <van-field v-model="product.chamberlain" label="收款人" readonly />
        <van-field v-model="product.amount" label="收款金额" readonly />
        <van-field
          v-model="product.receiving_account"
          label="收款账户"
          readonly
        />
        <van-field
          v-model="product.remark"
          rows="3"
          autosize
          label="备注"
          type="textarea"
        />
        <div class="file-list-body" v-if="product.file_list != null">
          <!-- <p style="margin-top: 15px;">文件列表</p> -->
          <h2 class="van-form-title">文件列表</h2>
          <div class="file-body">
            <div
              class="file-body-item"
              v-for="(itemFile, index2) in product.file_list"
              :key="index2"
            >
              <div class="img-body" v-if="isTypeImage(itemFile.file_type)">
                <van-image
                  width="100"
                  height="100"
                  fit="cover"
                  :src="fileUrl + itemFile.file_id"
                  @click="imgLook(fileUrl + itemFile.file_id)"
                />
              </div>
              <div
                class="img-body"
                v-else-if="isTypeMp4(itemFile.file_type)"
                @click="lookVideo(fileUrl + itemFile.file_id)"
              >
                <i class="file-icon van-icon-description"></i>
                <div class="file-name">查看视频</div>
              </div>
              <div class="img-body" v-else @click="clickFile">
                <i class="file-icon van-icon-description"></i>
                <div class="file-name">
                  {{ itemFile.file_name }}.{{ itemFile.file_type }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- <div v-show="this.product.purchase_status == 1 || this.product.purchase_status == 5">
				<h2 class="van-form-title">付款信息</h2>
				<van-field v-model="product.chamberlain" label="收款人" readonly />
				<van-field v-model="product.amount" label="收款金额" readonly />
				<van-field v-model="product.receiving_account" label="收款账户" readonly />
				<van-field v-model="product.remark" rows="3" autosize label="备注" type="textarea" />
				<div class="file-list-body" v-if="product.file_list != null">
					<p style="margin-top: 15px;">文件列表</p>
				</div>
			</div> -->
    </van-form>

    <audit-btn
      v-if="audit_btn"
      @audit="auditcheck"
      v-bind:content="product"
    ></audit-btn>
  </div>
</template>

<script>
import navbar from "@/components/navBar/index";
import auditBtn from "@/components/auditBtn/index";
import { post } from "@/api/post";
import { Toast } from "vant";
import global_url from "@/utils/global";
import { isImage, isMp4 } from "@/utils/tool";
import { ImagePreview } from "vant";
export default {
  name: "customer",
  components: {
    navbar,
    "audit-btn": auditBtn,
  },
  data() {
    return {
      title: "采购详情",
      purchase_status: [
        "采购审核",
        "董事长审核",
        "已通过",
        "已驳回",
        "已办结",
        "财务审核",
      ],
      popup: {
        select: false,
      },
      form: {
        requestType: "product_data_from_id",
        purchase_id: this.$route.query.id,
      },
      product: {},
      auditShow: false,
      audit_btn: false,
      fileUrl: this.findUrl(),
    };
  },
  mounted() {
    this.getDetails();
    if (this.$route.query.p != "false") {
      this.audit_btn = true;
    }
  },
  methods: {
    getDetails() {
      post(this.form)
        .then((res) => {
          this.product = res.obj;
          console.log();
          console.log(this.product, 4444);
          if (res.obj.purchase_status > 1) {
            this.auditShow = true;
          }
        })
        .catch(() => {
          Toast.fail("数据异常");
        });
    },
    auditcheck(mess) {
      let type = 3;
      if (!this.form.purchase_id) {
        return Toast.fail("数据异常");
      }
      if (mess == "") {
        console.log(mess, "数据原因");
        if (this.product.purchase_status == 1) {
          type = 5;
        } else if (this.product.purchase_status == 5) {
          type = 4;
        } else {
          type = 2;
        }
      }
      post({
        requestType: "purchase_order_approval",
        purchase_id: this.form.purchase_id,
        purchase_status: type,
        check_remark: mess,
      })
        .then(() => {
          this.$route.params.listRefresh = true;
          this.$router.go(-1);
          return Toast.success("审核成功!");
        })
        .catch(() => {
          return Toast.fail("数据异常");
        });
    },
    isTypeMp4(name) {
      return isMp4(name);
    },
    isTypeImage(name) {
      return isImage(name);
    },
    findUrl() {
      return global_url.fileUrl;
    },
    imgLook(url) {
      ImagePreview({
        images: [url],
      });
    },
    clickFile() {
      return Toast.fail("暂不支持该文件查看");
    },
  },
};
</script>

<style lang="scss" scoped>
.van-form-title {
  margin: 0;
  padding: 20px 16px 16px;
  color: rgba(69, 90, 100, 0.6);
  font-weight: normal;
  font-size: 14px;
  line-height: 16px;
}

.file-body {
  width: calc(100% + 10px);
  padding: 0;
  display: flex;
  flex-wrap: wrap;
  margin: 0 16px;
  .file-body-item {
    list-style: none;
    flex: 0 0 calc(33.33% - 10px);
    margin-right: 10px;
  }
}

.schedule {
  margin-top: 30px;
  // overflow: hidden;

  .van-panel__content {
    padding: 10px 20px;
  }
  & + .schedule {
    margin-top: 15px;
  }
  &-body {
    font-size: 0.8em;
    position: relative;
    p {
      margin: 0.5em 0;
    }
    .tag-status {
      position: absolute;
      right: 0;
      top: 0;
    }
  }
  .file-body {
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    -webkit-flex-wrap: wrap;
    flex-wrap: wrap;
    margin-top: 15px;

    // float: left;
    // margin-left: 15px;
    // &:nth-child(3n-2) {
    // 	margin-left: 0;
    // }
    &-item {
      position: relative;
      margin: 0 8px 8px 0;
      cursor: pointer;
      .img-body {
        display: block;
        width: 80px;
        height: 80px;
        overflow: hidden;
        border-radius: 8px;
        box-shadow: #ebedf0 0 4px 12px;
        text-align: center;
        img {
          object-fit: cover;
          display: block;
          width: 100%;
          height: 100%;
        }
        .file-icon {
          position: relative;
          display: inline-block;
          font: normal normal normal 14px/1 "vant-icon";
          font-size: inherit;
          text-rendering: auto;
          -webkit-font-smoothing: antialiased;
          color: #646566;
          font-size: 20px;
          margin-top: 15px;
        }
        .file-name {
          box-sizing: border-box;
          width: 100%;
          margin-top: 4px;
          padding: 0 4px;
          color: #646566;
          font-size: 12px;
          text-align: center;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 3;
          overflow: hidden;
        }
      }
    }
  }
}
</style>
